import styled from 'styled-components';
import { mixin } from '@wconcept/wconcept-ui-renewal/styles/index';

interface IProps {
  $bgColor?: string;
  $textColor?: string;
  $pointColor?: string;
  $emphasisTextColor?: string;
}

// 기본 배경 색상
const getBackgroundColor = (props: IProps) => {
  if (props.$bgColor === 'white') return '#fff';
  if (props.$bgColor === 'black') return '#000';
  if (
    props.$bgColor &&
    props.$textColor &&
    props.$pointColor &&
    props.$emphasisTextColor
  ) {
    return props.$bgColor;
  }
  return props.$bgColor;
};

// 기본 텍스트 색상 (PC)
const getTextColor = (props: IProps) => {
  if (props.$bgColor === 'white') return '#000';
  if (props.$bgColor === 'black') return '#fff';
  if (
    props.$bgColor &&
    props.$textColor &&
    props.$pointColor &&
    props.$emphasisTextColor
  ) {
    return props.$textColor;
  }
  return '#999';
};

// 기본 텍스트 색상 (MO)
const getMobileTextColor = (props: IProps) => {
  if (props.$bgColor === 'white' || props.$bgColor === 'black') return '#999';
  if (props.$textColor) return props.$textColor;
  return '#999';
};

// active 배경 색상
const getActiveBackgroundColor = (props: IProps) => {
  if (props.$bgColor === 'white') return '#000';
  if (props.$bgColor === 'black') return '#fff';
  if (
    props.$bgColor &&
    props.$textColor &&
    props.$pointColor &&
    props.$emphasisTextColor
  ) {
    return props.$pointColor;
  }
  if (props.$pointColor) return props.$pointColor;
  if (props.$bgColor === 'black') return '#fff';
  if (props.$bgColor === 'white') return '#000';
  return '#000';
};

// active 텍스트 색상
const getActiveTextColor = (props: IProps) => {
  if (props.$bgColor === 'white') return '#fff';
  if (props.$bgColor === 'black') return '#000';
  if (
    props.$bgColor &&
    props.$textColor &&
    props.$pointColor &&
    props.$emphasisTextColor
  ) {
    return props.$emphasisTextColor;
  }
  return props.$bgColor === 'black' ? '#000' : '#fff';
};

// 모바일 active 텍스트 색상
const getMobileActiveTextColor = (props: IProps) => {
  if (props.$bgColor === 'white') return '#000';
  if (props.$bgColor === 'black') return '#fff';
  if (
    props.$bgColor &&
    props.$textColor &&
    props.$pointColor &&
    props.$emphasisTextColor
  ) {
    return props.$pointColor;
  }
  return '#999';
};

export const NavigationItem = styled.div<IProps>`
  width: inherit;
  height: inherit;

  .area-click {
    position: relative;
    height: 100%;
    font-weight: 600;
    font-size: 14px;
    padding: 0 10px;
    white-space: nowrap;
    background: ${props => getBackgroundColor(props)};
    color: ${props => getMobileTextColor(props)};
  }

  &.active .area-click {
    color: ${props => getMobileActiveTextColor(props)};
  }

  @media ${({ theme }) => theme.media.smMax} {
    .area-click {
      font-size: ${mixin.pxToVw('14')};
      padding: ${mixin.pxToVw('0 10')};
    }
  }

  @media ${({ theme }) => theme.media.pc} {
    width: 100%;
    height: 60px;

    .area-click {
      width: 100%;
      font-size: 16px;
      padding: 0;
      background: ${props => getBackgroundColor(props)};
      color: ${props => getTextColor(props)};
    }

    &.active {
      border-color: ${props => getActiveBackgroundColor(props)} !important;

      .area-click {
        background: ${props => getActiveBackgroundColor(props)};
        color: ${props => getActiveTextColor(props)};
      }
    }
  }
`;
